/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { PropertyMatrixBaseService } from '../property-matrix-base-service';
import { PropertyMatrixConfiguration } from '../property-matrix-configuration';
import { PropertyMatrixStrictHttpResponse } from '../property-matrix-strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { PropertyAddressDetailsVm } from '../models/property-address-details-vm';
import { SellingMyPropertyFormVm } from '../models/selling-my-property-form-vm';

@Injectable({
  providedIn: 'root',
})
export class SellingMyPropertyService extends PropertyMatrixBaseService {
  constructor(
    config: PropertyMatrixConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiV1SellingMyPropertySaveSellingMyPropertyFormPost
   */
  static readonly ApiV1SellingMyPropertySaveSellingMyPropertyFormPostPath = '/api/v1/SellingMyProperty/SaveSellingMyPropertyForm';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1SellingMyPropertySaveSellingMyPropertyFormPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1SellingMyPropertySaveSellingMyPropertyFormPost$Response(params?: {
    context?: HttpContext
    body?: SellingMyPropertyFormVm
  }
): Observable<PropertyMatrixStrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, SellingMyPropertyService.ApiV1SellingMyPropertySaveSellingMyPropertyFormPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as PropertyMatrixStrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1SellingMyPropertySaveSellingMyPropertyFormPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1SellingMyPropertySaveSellingMyPropertyFormPost(params?: {
    context?: HttpContext
    body?: SellingMyPropertyFormVm
  }
): Observable<void> {

    return this.apiV1SellingMyPropertySaveSellingMyPropertyFormPost$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiV1SellingMyPropertyUpdatePropertyDetailsPost
   */
  static readonly ApiV1SellingMyPropertyUpdatePropertyDetailsPostPath = '/api/v1/SellingMyProperty/UpdatePropertyDetails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1SellingMyPropertyUpdatePropertyDetailsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1SellingMyPropertyUpdatePropertyDetailsPost$Response(params?: {
    propertyId?: number;
    context?: HttpContext
    body?: PropertyAddressDetailsVm
  }
): Observable<PropertyMatrixStrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, SellingMyPropertyService.ApiV1SellingMyPropertyUpdatePropertyDetailsPostPath, 'post');
    if (params) {
      rb.query('propertyId', params.propertyId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as PropertyMatrixStrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1SellingMyPropertyUpdatePropertyDetailsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1SellingMyPropertyUpdatePropertyDetailsPost(params?: {
    propertyId?: number;
    context?: HttpContext
    body?: PropertyAddressDetailsVm
  }
): Observable<void> {

    return this.apiV1SellingMyPropertyUpdatePropertyDetailsPost$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponse<void>) => r.body as void)
    );
  }

}
